import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface RecipeLogErrorProps {
    /** Short next-step line, tailored to where the error shows (modal vs page). */
    readonly recovery: string;
}

/** Shared error state for a failed cook-log fetch (recipe page + manage modal). */
export const RecipeLogError = ({ recovery }: RecipeLogErrorProps) => (
    <div className="py-2 text-center">
        <ExclamationTriangleIcon className="mx-auto mb-2 size-6 text-[var(--color-danger)]" />
        <p className="font-serif text-[15px] text-[var(--fg-2)]">Something went wrong.</p>
        <p className="mt-1 font-serif text-[14px] text-[var(--fg-muted)]">{recovery}</p>
    </div>
);
